/**
 * Created by matheusmorett on 23/04/18.
 */
import React, {Component} from 'react';

import "./ShareButtons.scss";

export default class ShareButtons extends Component {

    static defaultProps = {
        title: "Adrena.me",
        url: window.location.href
    };

    handleClickFacebook(url) {
        url = "https://www.facebook.com/sharer/sharer.php?u=" + url;
        this.windowOpen(url);
    }

    handleClickLinkedin(url) {
        url = "http://www.linkedin.com/shareArticle?mini=true&url=" + url;
        this.windowOpen(url);
    }

    handleClickTwitter(url, title) {
        url = "https://twitter.com/intent/tweet?text=" + url + " " + title + " #adrena";
        this.windowOpen(url);
    }

    handleClickWhatsApp(url) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
            url = "whatsapp://send?text=" + url;
            window.open(url, "_blank");
        } else {
            url = "https://web.whatsapp.com/send?link=" + url;
            window.open(url, "_blank");
        }
    }

    windowOpen(url) {
        const x = window.screen.width/2 - 700/2;
        const y = window.screen.height/2 - 450/2;
        window.open(url, "_blank", "width=600,height=300,left="+x+",top="+y);
    }

    render() {

        const {title, url} = this.props;

        /* ************** REMOVENDO ESTE COMPONENTE ******************* */
        return ""

        // return (
        //     <div className="ShareButtons">
        //         Compartilhe com seus amigos
        //         <button onClick={() => this.handleClickFacebook(url)} className="icon facebook" target="_blank">
        //             <i className="fa fa-facebook-f" />
        //         </button>
        //         <button onClick={() => this.handleClickTwitter(url, title)} className="icon twitter">
        //             <i className="fa fa-twitter" />
        //         </button>
        //         <a onClick={() => this.handleClickWhatsApp(url)} target="_blank" className="icon whatsapp" >
        //             <i className="fa fa-whatsapp" />
        //         </a>
        //         <button onClick={() => this.handleClickLinkedin(url)} className="icon linkedin">
        //             <i className="fa fa-linkedin" />
        //         </button>
        //     </div>
        // )

    }

}



